import { CalendarDays } from "lucide-react";
import { el as elLocale } from "date-fns/locale";
import { useI18n } from "../../i18n";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Calendar } from "../ui/calendar";
import { fmtDate } from "../../lib/format";

const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const fromIso = (iso) => (iso ? new Date(`${iso}T12:00:00`) : undefined);

export const DateField = ({ value, onChange, testId }) => {
  const { lang } = useI18n();
  return (
  <Popover>
    <PopoverTrigger asChild>
      <button type="button" data-testid={testId} className="mt-1 flex h-11 w-full items-center justify-between rounded-xl border border-slate-200 bg-white px-3 text-sm text-navy outline-none focus:border-brand focus:ring-4 focus:ring-brand/15">
        <span>{value ? fmtDate(value) : "—"}</span>
        <CalendarDays className="h-4 w-4 text-slate-400" />
      </button>
    </PopoverTrigger>
    <PopoverContent className="w-auto p-0" align="start">
      <Calendar mode="single" weekStartsOn={1} locale={lang === "el" ? elLocale : undefined} selected={fromIso(value)} defaultMonth={fromIso(value)} onSelect={(d) => onChange(d ? toIso(d) : "")} initialFocus />
    </PopoverContent>
  </Popover>
  );
};
